import Phaser from "phaser";

const RADIUS = 14;
const OUTER_W = 4;
const INNER_W = 2;
const INNER_INSET = 2;

// Shared fixed width for the quests-screen card widgets (CraftWidget, MerchantWidget,
// RecipeWidget, DailyChallengeWidget) so their columns line up instead of each card
// sizing itself to its own content.
export const QUEST_WIDGET_W = 280;

export function drawWidgetBackground(
  g: Phaser.GameObjects.Graphics,
  x: number,
  y: number,
  w: number,
  h: number,
): void {
  g.clear();
  // Drop shadow
  g.fillStyle(0x000000, 0.45);
  g.fillRoundedRect(x + 3, y + 6, w, h, RADIUS);
  // Dark outer ring
  g.fillStyle(0x060a12, 1);
  g.fillRoundedRect(x - OUTER_W, y - OUTER_W, w + OUTER_W * 2, h + OUTER_W * 2, RADIUS + OUTER_W);
  // Main fill
  g.fillStyle(0x0c1c38, 1);
  g.fillRoundedRect(x, y, w, h, RADIUS);
  // Inner bright rim
  g.lineStyle(INNER_W, 0x5b9bd5, 1);
  g.strokeRoundedRect(x + INNER_INSET, y + INNER_INSET, w - INNER_INSET * 2, h - INNER_INSET * 2, RADIUS - 1);
}

// Plain black rounded panel — used behind components (like DailyStarsComponent) that
// don't draw their own card background, so they read consistently alongside the widgets
// above that do.
export function drawBlackPanelBackground(
  g: Phaser.GameObjects.Graphics,
  x: number,
  y: number,
  w: number,
  h: number,
): void {
  g.clear();
  g.fillStyle(0x000000, 0.55);
  g.fillRoundedRect(x, y, w, h, RADIUS);
}
